import Layout from "@/components/layout/Layout";
import SEO, { localBusinessSchema } from "@/components/SEO";
import Hero from "@/components/home/Hero";
import Services from "@/components/home/Services";
import Craftsmanship from "@/components/home/Craftsmanship";
import About from "@/components/home/About";
import Gallery from "@/components/home/Gallery";
import MiracleCoat from "@/components/home/MiracleCoat";
import Clients from "@/components/home/Clients";
import CTA from "@/components/home/CTA";

const Index = () => {
  return (
    <Layout>
      <SEO
        title="Hyper Haus | PPF, Window Tint & Vinyl Wraps in LA"
        description="Paint protection film (PPF), window tint, ceramic coating, commercial signs in Los Angeles. Installation backed by 40+ years of hypercar craftsmanship."
        canonical="/"
        jsonLd={localBusinessSchema}
      />
      <Hero />
      <Services />
      <Craftsmanship />
      <About />
      <MiracleCoat />
      <Gallery />
      <Clients />
      <CTA />
    </Layout>
  );
};

export default Index;
